import useUserContext from './useUserContext.js';
import { makeCurrentUser } from './UserProvider/helpers.js';

function useCurrentUser() {
  return makeCurrentUser(useUserContext());
}

export default useCurrentUser;
